// src/config.js

// Assuming you're using Create React App, environment variables should be prefixed with REACT_APP_
const isDebug = process.env.REACT_APP_DEBUG === 'true';
const hostname = isDebug ? 'http://localhost:5001' : '/api';

export { isDebug, hostname };